export default {"src":"/_next/static/media/el-salvador.c275dc25.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};